export function debugWallet() {
    console.log('=== OP_NET Wallet Debug ===');
    console.log('window.opnet:', typeof window.opnet, window.opnet);
    
    if (window.opnet) {
        console.log('Available methods:');
        console.log('- getAccounts:', typeof window.opnet.getAccounts);
        console.log('- requestAccounts:', typeof window.opnet.requestAccounts);
        console.log('- getPublicKey:', typeof window.opnet.getPublicKey);
        console.log('- signMessage:', typeof window.opnet.signMessage);
        console.log('- on:', typeof window.opnet.on);
        
        console.log('\nAll opnet keys:', Object.keys(window.opnet));
        
        try {
            console.log('\nСпроба отримати акаунти...');
            window.opnet.getAccounts()
                .then(accounts => console.log('✅ Акаунти:', accounts))
                .catch(err => console.log('ℹ️ Акаунти не підключені:', err.message));
        } catch (e) {
            console.log('❌ Помилка виклику getAccounts:', e.message);
        }
    }
    console.log('========================');
}
